<wk-icon-close-sprite-pds3 />
<wk-icon-filled-check-circle-sprite-pds3 />
<wk-icon-filled-stop-sign-sprite-pds3 />
<wk-icon-filled-stop-sign-sprite-pds3 />

<ng-template #contentPart let-part>
    @if (part.url) {
        <a target="_blank" rel="noopener noreferrer" [href]="part.url | translate">
            {{ part.text | translate: part.textParams }}
        </a>
    } @else if (part.isHtml) {
        <span [innerHTML]="part.text | translate: part.textParams"></span>
    } @else {
        {{ part.text | translate: part.textParams }}
    }
</ng-template>

<ng-template #multipartContent let-multipart>
    @for (part of multipart; track $index) {
        <ng-container [ngTemplateOutlet]="contentPart" [ngTemplateOutletContext]="{ $implicit: part }" />
    }
</ng-template>

<notification-toast-container-pds3 position="top-right">
    @for (notification of notifications(); track notification.id) {
        <notification-pds3
            (close)="closeNotification(notification.id)"
            slideDirection="right"
            [isOpen]="notification.isOpen"
            [autoCloseTimeoutMS]="notification.autoCloseTimeoutMs"
            [type]="notification.type"
        >
            <div *notificationHeadingPds3>
                {{ notification.heading ?? DEFAULT_HEADINGS[notification.type] | translate: notification.headingParams }}
            </div>
            <span *notificationContentPds3>
                @if (isMultipartContent(notification.content)) {
                    <ng-container [ngTemplateOutlet]="multipartContent" [ngTemplateOutletContext]="{ $implicit: notification.content }" />
                } @else {
                    <ng-container [ngTemplateOutlet]="contentPart" [ngTemplateOutletContext]="{ $implicit: notification.content }" />
                }
            </span>
        </notification-pds3>
    }
</notification-toast-container-pds3>
